import React from "react";
import { foodCalculators } from "./ConstantsFoodCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrices Alimentaires";
const DESCRIPTION =
  "Calculatrices Alimentaires pour adapter vos recettes, portions et conversions en cuisine. Resultat rapide et pratique pour cuisiner avec plus de precision chaque jour.";
const KEYWORDS =
  "s alimentaires, calculatrice s alimentaires, calcul en ligne, cuisine, recette, conversion, resultat rapide";
const OG_URL = 'https://do-calculate.com/fr/food-calculators/';
function CalculatorsList() {
  return (
    <div className="container rtl-container">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div>
        <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
        <hr />
        <div className="alert alert-secondary" role="alert">
          <p>{DESCRIPTION} </p>
        </div>
      </div>
      <hr />
      <table >
        <thead>
          <tr>
            <th >Calculatrice</th>
            <th >Description</th>
          </tr>
        </thead>
        <tbody>
          {foodCalculators.map((calculator, index) => (
            <tr key={index}>
              <td>
                <a href={calculator.link}>
                  {" "}
                  <h2 style={{ fontSize: "14px" }}>{calculator.name}</h2>{" "}
                </a>
              </td>
              <td>
                <p>{calculator.description}</p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br />
    </div>
  );
}
export default CalculatorsList;
